
// もっと見るボタンを押したとき
function openListArchive(){
  $(document).on('click','#more_list', function(){
    $("#more_list").css("display","none")
    $("#lists11").css("display","block");
    DAILY.restartMoniterFixedAdd();
  });
}

// リスト・アーカイブの記事一覧表示
function getListArchive(k,genreList,cut){
  $(document).on('click','#load',function(){
    $.getJSON(genreList,function(data){
      var len = data.length;//多メディア最終行はダミーデータのため
      var num;
      var reg =/daily\.c\.yimg/g;
      if(len-k<=10){//10本づつ表示
        num = len;
        $("#load").hide();
      }
      else{
        num = k+10;
      }
      for(i=k; i<num; i++){
        var $honbun= data[i].honbun.substr(0,(cut))+"…";
        var $li =$('<li>');
        var $a = $('<a href="' + data[i].url + '"></a>');
        var $article = $('<article>',{"class":"listItem"});
        var $divOutline = $('<div>',{"class":"outline"});
        $divOutline.append('<h1 class="ttl">' + data[i].headline + '</h1>');
        $divOutline.append('<div class="txt">' + $honbun + '</div>');
        $divOutline.append('<time class="date">' + data[i].dateRelease_yyyy +'.'+ data[i].dateRelease_MM + '.' +data[i].dateRelease_dd +'</div>');
        $article.append($divOutline);
        if("photo" in data[i]){
          var $divThumb = $('<div>',{"class":"thumb-wrapper"});
          var filePath = ((data[i].photo.length) == undefined)
            ? data[i].photo.filepath +'e_'+ data[i].photo.filename
            : data[i].photo[0].filepath+'e_'+ data[i].photo[0].filename ;
          filePath = filePath.replace(reg,"i.daily");
          var $fig = $('<figure class="thumb"><img src="' + filePath + '" /></figure>');
          $divThumb.append($fig);
          $article.append($divThumb);
        }
        $a.append($article);
        $li.append($a);
        $('#article_list_all').append($li);
      }
      k=k+10;
      DAILY.restartMoniterFixedAdd();
    });
  });
}

//記事、写真ページのジャンル別記事一覧表示
function loadGetListArticle(genreList) {
  $.getJSON(genreList,function(data){
    var reg = /daily\.c\.yimg/g;
    for(i=0; i<15; i++){
      if(data[i].dummy===null){
        break;
      }
      var $li =$('<li>');
      if (data[i].photofilename !== undefined) {
        $li.addClass('addThumb');
      }
      var $a = $('<a href="' + data[i].url + '"></a>');
      var $article = $('<article>');
      $article.append('<h1 class="ttl">' + data[i].headline + '</h1>');
      if (data[i].photofilename !== undefined) {
        var photoFilePath = data[i].photofilepath.replace(reg,"i.daily");
        var $fig = $('<figure class="thumb"><img src="' + photoFilePath + "b_" + data[i].photofilename + '"></figure>');
      }
      else{
        var $fig =null;
      }
      $article.append($fig) ;
      $a.append($article);
      $li.append($a);
      $('#mainGenreList').append($li);
    }
  });
}
//関連記事
function showRelationJson(selfurl){
  var relationList='//ra.dga.jp/cgi-bin/ra/KAN041-JSONP?cs=utf8&l='+encodeURI(selfurl);
  DAILY.getRelationJson({
    url: relationList,
    id: '#relationNews'
  });
}
// 関連記事(写真付き)
function showRelationJsonWithPhoto(selfurl){
  var relationList='//ra.dga.jp/cgi-bin/ra/KAN041-JSONP?cs=utf8&l='+encodeURI(selfurl);
  DAILY.getRelationJsonWithPhoto({
    url: relationList,
    id: '#relationNews'
  }, function(error){
    if (error === null){
      var slotName = 'dspc-relation_img';
      var slotDiv = document.createElement('div');
      slotDiv.id = slotName;
      let node = document.querySelector('#relationNews li:nth-child(4)');
      node.parentNode.insertBefore(slotDiv, node);
      googletag.cmd.push(function() {
        var slot = googletag.defineSlot('/21662775423/dspc/relation_img', ['fluid', [1, 1]], slotName).addService(googletag.pubads());
        googletag.display(slotName);
        googletag.pubads().refresh([slot]);
      });
    }
    else{console.log(error);}
  });
}
